import { Toast,Dialog} from 'vant';
/**当前时间的年月日函数
 * type 返回的格式YYYY-MM-DD 默认
 * seperator:默认为"-" 连接符
 * timeStamp:需要转换的时间,默认为当前时间
 */
function getDate(type="YYYY-MM-DD",seperator="-",timeStamp) {
  let date = new Date()
  if (timeStamp) {
    date = new Date(timeStamp)
  }
  let year = date.getFullYear()
  let nowMonth = date.getMonth()+1
  let strDate = date.getDate()
  // 对月份进行处理，1-9月在前面添加一个“0”
  if (nowMonth >= 1 && nowMonth <= 9) {
    nowMonth = "0" + nowMonth;
  }
  // 对月份进行处理，1-9号在前面添加一个“0”
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (type=="YYYY-MM-DD") {
    return year + seperator + nowMonth + seperator + strDate;
  }
  if (type=="YYYY-MM") {
    return year + seperator + nowMonth;
  }
  if (type=="YYYY") {
    return year;
  }
}

// 节流函数
function throttle(func, delay) {
  let timeoutId;
  return function(...args) {
    if (!timeoutId) {
      timeoutId = setTimeout(() => {
        func.apply(this, args);
        timeoutId = null;
      }, delay);
    }
  };
}
// 防抖函数
function debounce(func, delay) {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
// url参数获取
// 如str = '?params=%7B%22pn%22%3A%22managementIndex%22%2C%22data%22%3A%7B%22a%22%3A1%2C%22b%22%3A%22adsads%22%7D%7D'
function getUrlParam(str) {
  try {
    if(str){
      const arr = str.split('=')
      return JSON.parse(decodeURIComponent(arr[1]))
    }
  } catch(e) {
    console.log('传入的不是值',e)
  }

}

function isIos() {
  const uA = navigator.userAgent.toLowerCase();
  const iphone = uA.match(/iphone os/i) == "iphone os";
  if (iphone) {
    return true;
  } else {
    return false;
  }
}

function isAndroid() {
  const uA = navigator.userAgent.toLowerCase();
  const android = uA.match(/android/i) == "android";
  if (android) {
    return true;
  } else {
    return false;
  }
}

// 打电话
function callPhone(phoneNumber) {
  if (isAndroid()) {
    mobile.callPhone(phoneNumber + "");
  } else {
    location.href = 'tel:' + phoneNumber;
  }
}

// 判断两个时间的跨度
/**
 * time1:起始时间 时间戳
 * time2:结束时间 时间戳
 * m:相差月份 1 2 3...
 */
function completeDate (time1, time2, m) {
  // let timeArr1 = time1.split('-'),timeArr2 = time2.split('-')
  // const year1 = timeArr1[0] *1
  // const year2 = timeArr2[0] *1
  // const month1 = timeArr1[1] *1
  // const month2 = timeArr2[1] *1
  // const day1 = timeArr1[2] *1
  // const day2 = timeArr2[2] *1
  const year1 = time1.getFullYear()
  const year2 = time2.getFullYear()
  const month1 = time1.getMonth() + 1
  const month2 = time2.getMonth() + 1
  const day1 = time1.getDate()
  const day2 = time2.getDate()
  if (year2 === year1) { // 判断两个日期 是否是同年
    if (month2 - month1 > m) { // 相差是否 在m个月中
      return false
    } else if (month2 - month1 === m) { // 如果正好为 m月 判断天数
      if (day2 > day1) {
        return false
      }
    }
  } else { // 不同年
    if (year2 - year1 > 1) {
      return false
    }
    else if (year2 - year1 === 1) {
      if (month2 > m || month1 + m - month2 < 12) {
        return false
      }
      else if (month1 + m - month2 === 12) { // 正好为m月 判断天数
        if (day2 > day1) {
          return false
        }
      }
    }
  }
  return true
}
/**
 *  经纬度
 */
function getLocationInfo() {
  var loctionStr;
  if (isIos()) {
    var payload = {"type": "JSbridge", "functionName": 'getLocationInfo'};
    loctionStr = prompt(JSON.stringify(payload));
  } else {
    if (window.mobile) {
      if (isAndroid()) {
        loctionStr = mobile.getLoctionInfoData();
      }
    }
  }
  return loctionStr;
}

/**
 *  检查获取经纬度时的必要权限
 */
function getLocationPermission() {
  let locationPermission;
  if (isIos()) {
    locationPermission = true;
  } else {
    if (window.mobile) {
      if (isAndroid()) {
        locationPermission = mobile.getLocationPermission();
      }
    }
  }
  return locationPermission;
}
// 唤起第三方地图应用
function evocativeApp(type, url) {
  if (isIos()) {
    window.webkit.messageHandlers.evocativeApp.postMessage(['' + type, url]);
  } else {
    if (window.mobile) {
      if (isAndroid()) {
        mobile.evocativeApp(type, url);
      }
    }
  }
}

// 检查“位置服务”是否开启
function hasLocationService() {
  if (isIos()) {
    let payload = {"type": "JSbridge", "functionName": 'isLocationServices'};
    return prompt(JSON.stringify(payload));
  } else {
    if (window.mobile) {
      if (isAndroid()) {
        return mobile.hasLocationService();
      }
    }
  }
}

// 跳转“定位服务”设置页
function jumpLocationService() {
  if (isIos()) {
    window.webkit.messageHandlers.jumpLocationServicesUI.postMessage({});
  } else {
    if (window.mobile) {
      if (isAndroid()) {
        mobile.jumpLocationService();
      }
    }
  }
}

// 位置权限是否开启
function hasLocationPerFlag() {
  if (isIos()) {
    let payload = {"type": "JSbridge", "functionName": 'isLocationPermission'};
    return prompt(JSON.stringify(payload));
  } else {
    if (window.mobile) {
      if (isAndroid()) {
        return mobile.hasLocationPerFlag();
      }
    }
  }
}

// 跳转“位置权限”设置页
function jumpLocationPerFlag() {
  if (isIos()) {
    window.webkit.messageHandlers.jumpLocationPermissionUI.postMessage({});
  } else {
    if (window.mobile) {
      if (isAndroid()) {
        mobile.jumpLocationPerFlag();
      }
    }
  }
}
// 获取当前经纬度
function getCurLocation(callback){
  // const toast1 = Toast.loading({
  //   message: '加载中...',
  //   forbidClick: true,
  //   duration: 0
  // });
   // 位置服务是否开启
  let haslocService = false,longitude = null , latitude = null
  haslocService = hasLocationService();
  if ((haslocService === '1' || haslocService === true) && haslocService !== '0') {
      // 位置权限是否开启
      let hasLocPerFlag = false;
      hasLocPerFlag = hasLocationPerFlag();
      if ((hasLocPerFlag === '1' || hasLocPerFlag === true) && hasLocPerFlag !== '0') {
          let locationInfoStr = getLocationInfo();
          let jwdJson = null;
          if (locationInfoStr) {
              jwdJson = JSON.parse(locationInfoStr);
              if (jwdJson.code === 200) {
                latitude = jwdJson.data.lat;
                longitude = jwdJson.data.lng;
              }
              // toast1.clear()
              callback&&callback(latitude,longitude)
          } else {
              locationInfoStr = getLocationInfo();
              if (locationInfoStr) {
                  jwdJson = JSON.parse(locationInfoStr);
                  if (jwdJson.code === 200) {
                    latitude = jwdJson.data.lat;
                    longitude = jwdJson.data.lng;
                  }
                  // toast1.clear()
                  callback&&callback(latitude,longitude)
              } else {
                 let timer = null
                 timer =  setTimeout(function () {
                      locationInfoStr = getLocationInfo();
                      if (locationInfoStr) {
                          jwdJson = JSON.parse(locationInfoStr);
                          if (jwdJson.code === 200) {
                            latitude = jwdJson.data.lat;
                            longitude = jwdJson.data.lng;
                          }

                      }
                      // toast1.clear()
                      callback&&callback(latitude,longitude)
                   clearTimeout(timer)
                  }, 2000)
              }
          }
      } else {
          // 显示“请开启定位功能授权，请务必选择始终允许”
          Dialog.confirm({
            title: '提示',
            message: '请开启定位功能授权，请务必选择始终允许',
            confirmButtonText:'去设置',
            confirmButtonColor:'#34bf00',
            overlayStyle: { 'background-color': 'rgba(0,0,0,0.45)' },
            className: 'van-newDialog',
          }).then(() => {
              jumpLocationPerFlag()
            }).catch(()=>{})
            // toast1.clear()
          callback&&callback(latitude,longitude)
      }
  } else {
      // 显示“请开启定位功能”
      Dialog.confirm({
        title: '提示',
        message: '请开启定位功能',
        confirmButtonText:'去设置',
        confirmButtonColor:'#34bf00',
        overlayStyle: { 'background-color': 'rgba(0,0,0,0.45)' },
        className: 'van-newDialog',
      }).then(() => {
          jumpLocationService()
        }).catch(()=>{})
        // toast1.clear()
      callback&&callback(latitude,longitude)
  }
}

function preEvocativeApp(type,latObj) {
  let{latOfUser, lngOfUser, latOfShop, lngOfShop, shopName} = latObj
  if (!latOfUser || !lngOfUser || !latOfShop || !lngOfShop || !shopName) {
    Toast({message:"异常：唤起第三方地图应用",className:'van-newToast'});
    return;
  }
  let url;
  // 百度地图
  if (type === 1) {
    if (isIos()) {
      url = "baidumap://map/direction?origin=name:我的位置|latlng:" + latOfUser + "," + lngOfUser + "&destination=name:" + shopName + "|latlng:"
          + latOfShop + "," + lngOfShop + "&coord_type=gcj02&mode=riding&src=ios.yueKuaiGongYing.ridingNav";
    } else if (isAndroid()) {
      url = "baidumap://map/direction?origin=name:我的位置|latlng:" + latOfUser + "," + lngOfUser + "&destination=name:" + shopName + "|latlng:"
          + latOfShop + "," + lngOfShop + "&coord_type=gcj02&mode=riding&src=andr.yueKuaiGongYing.ridingNav";
    } else {
      Toast({message:"异常：唤起第三方地图应用",className:'van-newToast'});
      return;
    }
  }
  // 腾讯地图
  else if (type === 2) {
    // ios端/android端的唤起URI为同一个
    url = "qqmap://map/routeplan?type=bike&from=我的位置&fromcoord=" + latOfUser + "," + lngOfUser + "&to=" + shopName + "&tocoord="
        + latOfShop + "," + lngOfShop + "&referer=NJMBZ-TK4CD-ZUZ4C-PGI4T-WXEG5-AQFQS";
  }
  // 高德地图
  else if (type === 3) {
    if (isIos()) {
      url = "iosamap://path?sourceApplication=yueKuaiGongYing&slat=" + latOfUser + "&slon=" + lngOfUser + "&sname=我的位置&dlat="
          + latOfShop + "&dlon=" + lngOfShop + "&dname=" + shopName + "&dev=0&t=3&rideType=elebike";
    } else if (isAndroid()) {
      url = "amapuri://route/plan/?slat=" + latOfUser + "&slon=" + lngOfUser + "&sname=我的位置&dlat=" + latOfShop + "&dlon=" + lngOfShop
          + "&dname=" + shopName + "&dev=0&t=3&rideType=elebike";
    } else {
     // $('.evocativeAppErrorTips').click();
     Toast({message:"异常：唤起第三方地图应用",className:'van-newToast'});
      return;
    }
  } else {
   // $('.evocativeAppErrorTips').click();
    Toast({message:"异常：唤起第三方地图应用",className:'van-newToast'});
    return;
  }
  console.log(type, url);
  evocativeApp(type, url);
}

function setTimeoutFun (time, callBack) {    //延时器公共方法
  let tm = setTimeout(() => {
    clearTimeout(tm);
    callBack&&callBack();
  }, time)
}
/**
 * 调起扫描
 */
function startScan() {
  console.log('isIos()=====',isIos());
  console.log('isAndroid()=====',isAndroid());
  if (isAndroid()) {
    mobile.launchScan();
  } else {
    if (isIos()) {
      window.webkit.messageHandlers.startScan.postMessage(null);
    }
  }
}

// 扫码回调
function launchScanBack(result) {
  // alert(result);
  // rc([{name: 'result', value: '' + result}]);
  console.log('result=====launchScanBack===========',result);
}
// 从详情页返回列表页的标记 flag==add增加 remove删除 get获得
function takeRefreshFlag(flag){
  if (flag=='add') {
    window.globalData.refreshFlag = true
    return
  }
  if (flag=='remove') {
    window.globalData.refreshFlag = null
    return
  }
  if (flag=='get') {
    return window.globalData.refreshFlag
  }
}

// toast回调
function showToastBack(text, callBack,callbackTime=1500,position='middle') {
  const timer1 = setTimeout(() => {
    Toast({
      message: text,
      className:'van-newToast',
      position,
    });
    clearTimeout(timer1)
    const timer2 = setTimeout(() => {
      clearTimeout(timer2)
      callBack&&callBack()
    }, callbackTime)
  }, 200)
}

// function formatDataUtils(data,parmasObj){
//   let arr=[],bigTitleArr=[],resultArr
//    for (const key in data) {
//       if (Object.hasOwnProperty.call(data, key)) {
//           const element = data[key];
//           if (element!==null&&parmasObj[key]) {
//               arr.push({...parmasObj[key],value:element})
//               if (!bigTitleArr.includes(parmasObj[key].bigTitle)) {
//                   bigTitleArr.push(parmasObj[key].bigTitle)
//               }
//           }
//           let newArr =  bigTitleArr.map(v=>{
//            let newList = arr.filter(subv=>subv.bigTitle==v)
//            let subarr = []
//            for(var i = 0; i< newList.length; i += 4){
//               let minarr = newList.slice(i, i + 4)
//               subarr.push({
//                children:minarr,
//             });
//            }
//            return {
//               title: v,
//               list: subarr
//            }
//          })
//          resultArr = newArr
//       }
//    }
//    return resultArr
// }
function formatDataUtils(data,parmasObj){
   let arr=[],bigTitleArr=[],resultArr
   for (const key in parmasObj) {
      if (Object.hasOwnProperty.call(parmasObj, key)) {
          const element = data[key];
          if (element!==null&&element!==undefined) {
              arr.push({...parmasObj[key],value:element})
              if (!bigTitleArr.includes(parmasObj[key].bigTitle)) {
                  bigTitleArr.push(parmasObj[key].bigTitle)
              }
          }
      }
   }
    let newArr =  bigTitleArr.map(v=>{
    let newList = arr.filter(subv=>subv.bigTitle==v)
    let subarr = []
    for(var i = 0; i< newList.length; i += 4){
       let minarr = newList.slice(i, i + 4)
       let isShowChild = minarr.some(minarrItem=>!minarrItem.isHide)
       subarr.push({
        isShowChild: isShowChild,
        children:minarr,
     });
    }
    return {
       title: v,
       list: subarr
    }
   })
   resultArr = newArr
   return resultArr
}
export default{
  getDate,
  getUrlParam,
  throttle,
  debounce,
  isIos,
  isAndroid,
  callPhone,
  completeDate,
  getCurLocation,
  preEvocativeApp,
  setTimeoutFun,
  startScan,
  launchScanBack,
  takeRefreshFlag,
  showToastBack,
  formatDataUtils
}



// WEBPACK FOOTER //
// ./src/common/utils.js